import React from 'react';
import { Box, Grid, ListItemField } from '@common-fe/common-fe';

import CheckCardItem from './CheckCardItem';

interface Props {
  testId?: string;
  sentToField?: ListItemField;
  payToField?: ListItemField;
}

const CheckCardAddressRow: React.FC<Props> = ({ testId, sentToField, payToField }) => {
  if (!sentToField && !payToField) {
    return null;
  }

  return (
    <Grid
      width="100%"
      columns={['1fr', '1fr', '1fr']}
      gap={{ column: 'spacing12', row: 'spacing8' }}
      margin={{ top: 'spacing8' }}
    >
      {sentToField ? (
        <Box style={{ gridColumn: 'span 2' }}>
          <CheckCardItem
            testId={`${testId}_${sentToField.key}`}
            title={sentToField.title}
            value={sentToField.value}
            node={sentToField.node}
            style={{ ...sentToField.style, whiteSpace: 'normal', overflow: 'visible', textOverflow: 'clip' }}
          />
        </Box>
      ) : null}
      {payToField ? (
        <CheckCardItem
          testId={`${testId}_${payToField.key}`}
          title={payToField.title}
          value={payToField.value}
          node={payToField.node}
          style={payToField.style}
        />
      ) : null}
    </Grid>
  );
};

export default CheckCardAddressRow;
